"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var validators_1 = require("utils/form/validators");
var utils_1 = require("./utils");
var ExtUrlsField = function () {
    var submitting = (0, react_final_form_1.useFormState)({ subscription: { submitting: true } }).submitting;
    var _a = (0, react_final_form_1.useField)('pricingInsightsExtUrls').input, pricingInsightsExtUrls = _a.value, onChange = _a.onChange;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pricingInsightsExtUrls === null || pricingInsightsExtUrls === void 0 ? void 0 : pricingInsightsExtUrls.map(function (e, idx) { return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "pricingInsightsExtUrls[".concat(idx, "].productName"), color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.required)(), label: "Product Name ".concat(idx + 1), fullWidth: true }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 7 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "pricingInsightsExtUrls[".concat(idx, "].url"), color: "secondary", disabled: submitting, component: TextField_1.default, validate: utils_1.isValidNotionUrl, format: utils_1.makePublicNotionUrl, parse: utils_1.makePublicNotionUrl, label: "URL", fullWidth: true }) })), pricingInsightsExtUrls.length > 1 && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 1 }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.RemoveButton, { onClick: function () { return onChange(pricingInsightsExtUrls.filter(function (_, i) { return i !== idx; })); } }) })))] }, idx)); }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 10 }, { children: (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", icon: faPlus_1.faPlus, onClick: function () { return onChange(__spreadArray(__spreadArray([], __read(pricingInsightsExtUrls || []), false), [{}], false)); } }, { children: "Add another product" })) }))] }));
};
exports.default = ExtUrlsField;
